var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffc83d",
    d: "M12.313 5.531c0-2.9 2.124-3.583 3.312-3.562c2.413 0 3.082 2.009 3.281 3.078c.248 1.33.006 4.509-.106 5.969l-.003.041a2.3 2.3 0 0 1 .515-.057h3.858c1.56 0 2.83 1.27 2.83 2.83c0 .806-.259 1.535-.765 2.05c1.044.461 1.765 1.428 1.765 2.544c0 1.023-.463 1.92-1.364 2.418c.823.511 1.364 1.366 1.364 2.332c0 1.107-.543 2.069-1.598 2.533c.375.386.598.96.598 1.794c0 1.38-.969 2.502-2.83 2.502h-3.858q-.068 0-.134-.003h-3.131C5.609 30.172 5 23.406 5 20.656c0-5.156 2.298-6.689 4.34-8.051c.966-.644 1.875-1.25 2.457-2.183c.488-.783.515-1.5.515-4.89"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d67d00",
    d: "M19 11c-1.02.031-4 .594-4 2.969c0 1.25.469 1.953 1.031 2.344c-.562.25-1.062 1.178-1.062 2.328c0 1.28 1.062 2.218 1.062 2.218s-1.062 1.032-1.062 2.266c0 .932.408 1.62 1.062 2.088c-.354.2-1.062.893-1.062 2.068c0 1.401 1.308 2.575 3.87 2.68c-1.248-.231-1.855-1.375-1.855-2.46c0-.358.134-.934.467-1.442H23a.5.5 0 0 0 0-1h-5.411c-.405-.53-.605-1.218-.605-1.885c0-.416.157-1.088.546-1.674H23a.5.5 0 0 0 0-1h-5.25c-.513-.55-.766-1.325-.766-2.076c0-.357.116-.905.396-1.424H23a.5.5 0 0 0 0-1h-5.173c-.564-.597-.843-1.484-.843-2.17c0-.81.443-2.6 2.016-2.81z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.9a178784fd9ce67cd862bb36968145f8.svg";
export { ForwardRef as ReactComponent };